const releaseSettings = {
    eShopVersion: "2023.0.3"
}

export default releaseSettings;


// WEBPACK FOOTER //
// ./src/config/releaseSettings.js